// スクリーンサイズ 横 (ブレイクポイントに使用する)
export const DESKTOP_LARGE = 1800;
export const DESKTOP_MEDIUM = 1440;
export const DESKTOP = 1200;
export const TABLET_L = 900;
export const TABLET_P = 600;

// マージン 横
export const MOBILE_PADDING = 20;



// WEBPACK FOOTER //
// ./src/constants/index.js